/**
 * Copy for the expert "reference assistant" intro callout.
 *
 * A one-time composer banner shown to an expert once they've responded to an
 * inquiry, announcing the reference assistant (the "Add references" sheet) and a
 * one-time honorarium bonus for their first use. It rides the same server-backed
 * user-callouts "show once, then never again" mechanism as the On your honor
 * intro, and — like that banner — is the only place the doubled-honorarium
 * mechanic is stated for this feature.
 *
 * The two intros share the "double your honorarium" promise deliberately: a
 * composer-callout coordinator guarantees only one shows at a time, so an expert
 * never sees the promise twice at once.
 *
 * The banner only appears when Primum has found references ready to review for
 * one of the expert's answers, and its action opens the citation wizard on that
 * message — the same surface the in-chat prompt opens. The button deliberately
 * mirrors that in-chat button's styling so the callout builds muscle memory for
 * the same action. Earning the honorarium bonus is tracked server-side on
 * publish, not here.
 */
export const REFERENCE_ASSISTANT_INTRO_COPY = {
  badge: 'New',
  message:
    "Let Primum find your citations — it searches the literature for sources that support your answer, ready to add in a tap. We'll double your honorarium the first time you use it.",
  actionLabel: 'Let Primum find references',
  actionAccessibilityLabel: 'Let Primum find references for your statements',
  dismissAccessibilityLabel: 'Dismiss reference assistant announcement',
} as const;
